class RizonHeroSlider extends HTMLElement {
  connectedCallback() {
    this.track = this.querySelector('[data-hero-track]');
    this.slides = Array.from(this.querySelectorAll('[data-hero-slide]'));
    this.dots = Array.from(this.querySelectorAll('[data-hero-dot]'));
    this.duration = parseInt(this.getAttribute('data-autoplay'), 10) || 5000;
    this.index = 0;

    if (this.slides.length <= 1) return;

    this.style.setProperty('--rizon-progress-duration', `${this.duration}ms`);

    this.dots.forEach((dot, i) => {
      dot.addEventListener('click', () => this.goTo(i));
    });

    this.goTo(0);
  }

  disconnectedCallback() {
    window.clearTimeout(this.timer);
  }

  goTo(index) {
    window.clearTimeout(this.timer);
    this.index = index;

    this.slides.forEach((slide, i) => {
      slide.classList.toggle('is-active', i === index);
    });

    if (this.track) {
      this.track.style.transform = `translateX(-${index * 100}%)`;
    }

    this.dots.forEach((dot, i) => {
      const segment = dot.querySelector('.rizon-carousel-progress');
      if (!segment) return;
      segment.classList.remove('rizon-carousel-progress--active', 'is-filling');
      if (i === index) {
        segment.classList.add('rizon-carousel-progress--active');
      }
    });

    const activeSegment = this.dots[index]?.querySelector('.rizon-carousel-progress');
    if (activeSegment) {
      // Force reflow so re-adding the class restarts the fill transition.
      void activeSegment.offsetWidth;
      activeSegment.classList.add('is-filling');
    }

    this.timer = window.setTimeout(() => {
      this.goTo((this.index + 1) % this.slides.length);
    }, this.duration);
  }
}

if (!customElements.get('rizon-hero-slider')) {
  customElements.define('rizon-hero-slider', RizonHeroSlider);
}
